import {
  MapFeatureType,
  useFeatureInteractionContext,
} from 'features/siteMap/contexts/FeatureInteractionContext'
import { SVNumberInput } from 'features/siteMap/popupMenus/editMode/editFeature/SVNumberInput'
import { useTilesetMapFeatureHelpers } from 'features/siteMap/tilesetMap/features/useTilesetMapFeatureHelpers'
import isNil from 'lodash/isNil'
import React, { FC } from 'react'
import styled from 'styled-components'
import { ExtractKeys, SiteFeaturePrimitive } from 'types'

const GeometryProp = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

interface ScaleInputProps {
  feature: SiteFeaturePrimitive
  featureType: MapFeatureType
  inputId: string
  title: string
  geometryProp: NormalOrArray<ExtractKeys<SiteFeaturePrimitive['geometry']>>
  value: number
}

type NormalOrArray<T> = T | Array<T>

export const ScaleInput: FC<ScaleInputProps> = (props) => {
  const { setSelectedFeature } = useFeatureInteractionContext()
  const { updateFeaturePrimitive } = useTilesetMapFeatureHelpers()

  const updateFeatureProp = (
    e: React.ChangeEvent<HTMLInputElement>,
    geometryProp: NormalOrArray<ExtractKeys<SiteFeaturePrimitive['geometry']>>
  ) => {
    let val: number | null = parseFloat(e.target.value)
    if (isNaN(val)) val = null
    const newFeature = {
      ...props.feature,
      geometry: {
        ...props.feature.geometry,
      },
    } as SiteFeaturePrimitive
    if (Array.isArray(geometryProp)) {
      geometryProp.forEach((prop) => {
        // @ts-expect-error -- We assume that the prop is from the same feature-primitive kind as geometry, but ts doesn't know that
        newFeature.geometry[prop] = val
      })
    } else {
      // @ts-expect-error -- We assume that the prop is from the same feature-primitive kind as geometry, but ts doesn't know that
      newFeature.geometry[geometryProp] = val
    }
    updateFeaturePrimitive(newFeature, geometryProp)
    setSelectedFeature(
      isNil(newFeature.unit_id)
        ? {
            type: MapFeatureType.Unknown,
            featureID: newFeature.id,
          }
        : {
            type: MapFeatureType.Unit,
            unitID: newFeature.unit_id,
          }
    )
  }

  return (
    <GeometryProp>
      <div>{props.title}</div>
      <SVNumberInput
        id={props.inputId}
        value={(props.value ?? '') as number}
        step={0.5}
        width={60}
        onChange={(e) => updateFeatureProp(e, props.geometryProp)}
      />
    </GeometryProp>
  )
}
